const OPEN_QUOTES = ['"', "“", "”", "„", "‟", "❝", "❞", "＂"];
const CLOSE_QUOTES = ['"', "”", "“", "‟", "❞", "❝", "＂"];

function startsWithAny(s, chars) {
  return chars.some((c) => s.startsWith(c));
}
function endsWithAny(s, chars) {
  return chars.some((c) => s.endsWith(c));
}

/**
 * Ensures the quote is wrapped in ASCII double-quotes: " ... "
 * Handles curly quotes (e.g. “ ... ”) by treating them as quotes too.
 */
export function normalizeOuterDoubleQuotes(raw) {
  const s = String(raw || "").trim();
  if (!s) return "";

  const hasOpen = startsWithAny(s, OPEN_QUOTES);
  const hasClose = endsWithAny(s, CLOSE_QUOTES);

  let out = s;
  if (!hasOpen) out = `"${out}`;
  if (!hasClose) out = `${out}"`;

  return out;
}
